const defaultTranslate = (value) => value;

const normalizeText = (value = '') =>
  String(value)
    .replace(/\s+/g, ' ')
    .trim();

export const getFaqAnswerText = (faq, translate = defaultTranslate) => {
  const content = [];

  if (faq.answer) {
    content.push(translate(faq.answer));
  }

  if (faq.answerIntro) {
    content.push(translate(faq.answerIntro));
  }

  if (faq.answerList?.length) {
    content.push(faq.answerList.map((item) => translate(item)).join(' '));
  }

  if (faq.answerClosing) {
    content.push(translate(faq.answerClosing));
  }

  return normalizeText(content.filter(Boolean).join(' '));
};

export const buildFaqSchema = (faqData = [], translate = defaultTranslate) => {
  const mainEntity = faqData
    .map((faq) => {
      const question = normalizeText(translate(faq.question));
      const answer = getFaqAnswerText(faq, translate);

      if (!question || !answer) {
        return null;
      }

      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
        },
      };
    })
    .filter(Boolean);

  if (!mainEntity.length) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };
};

export const stringifyStructuredData = (schema) =>
  JSON.stringify(schema).replace(/</g, '\\u003c');
